export default __webpack_public_path__ + "static/media/img_step_lucia10_w.d4c1ba4b.jpg";